import { HTTP_AP_ListImports_Request_Filter, HTTP_AP_ListImports_Request_Sort } from '@api-new/importservice';
import { ImportTableRowModel } from '@platform/import/models/import-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';

export const importTableFilterDefaults: HTTP_AP_ListImports_Request_Filter = {
  name: '',
  companyIds: [],
  importTypes: null,
};

export const importTableRowDefinition: TableRowDefinitionModel<ImportTableRowModel, HTTP_AP_ListImports_Request_Sort>[] = [
  {
    columnLabel: 'status',
    columnKey: 'statusIcon',
    type: RowDefinitionTypeEnum.LabeledImg,
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Import type',
    columnKey: 'importTypeMapped',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '140px',
      max: '140px',
    },
  },
  {
    columnLabel: 'imported / total',
    columnKey: 'importedVsTotal',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '140px',
      max: '140px',
    },
  },
  {
    columnLabel: 'name',
    columnKey: 'name',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'company',
    columnKey: 'companyTradingName',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'creation date',
    columnKey: 'createdAt',
    type: RowDefinitionTypeEnum.DateWithTime,
    sortKey: 'byCreatedAt',
    width: {
      min: '170px',
      max: '170px',
    },
  },
];
